const videoBtnMobileSVG = `
<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_655_993" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="-1" width="19" height="21">
<path d="M0 -0.000102997H19V19.1394H0V-0.000102997Z" fill="white"/>
</mask>
<g mask="url(#mask0_655_993)">
<path d="M14.0311 17.1209C12.7091 17.9275 11.1584 18.3918 9.5 18.3918C4.66324 18.3918 0.742188 14.442 0.742188 9.56973C0.742188 4.69738 4.66324 0.747612 9.5 0.747612C14.3368 0.747612 18.2578 4.69738 18.2578 9.56973C18.2578 11.3815 17.7033 13.0657 16.7734 14.4668" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<path d="M12.9688 9.70267L7.75673 12.6448L7.75673 6.76056L12.9688 9.70267Z" fill="white" stroke="white"/>
</svg>
`
export default videoBtnMobileSVG



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/videoBtnMobileSVG.js